import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

Vue.use(Vuex)

//全局变量
const state = {
  //用户视频全局变量
  userInfo: {},   //当前登陆用户的信息
  roleList:[],   //角色集合
  permList:[],   //权限集合
  
  informChange:false,//个人信息变动
  examFile:[],//检查文件变动
  navbarPosition: 'left',//导航位置

  addRouter:0

}

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js